import React from 'react';
import { Card } from 'react-bootstrap';
import { ScatterChart, Scatter, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer } from 'recharts';

const WeeklyChart = ({ data }) => {
  // Formatear datos para el gráfico
  const formattedData = data.map(item => ({
    fecha: new Date(item.fecha).toLocaleDateString(),
    caudal_promedio: parseFloat(item.caudal_promedio.toFixed(2))
  }));

  // Función para formatear las fechas en el tooltip
  const CustomTooltip = ({ active, payload }) => {
    if (active && payload && payload.length) {
      return (
        <div className="custom-tooltip bg-white p-2 shadow-sm border">
          <p className="mb-1"><strong>Fecha:</strong> {payload[0].payload.fecha}</p>
          <p className="mb-0"><strong>Caudal promedio:</strong> {payload[0].payload.caudal_promedio} m³/h</p>
        </div>
      );
    }
    return null;
  };

  return (
    <Card className="mb-4">
      <Card.Header as="h6">Caudal Promedio - Últimos 7 Días (m³/h)</Card.Header>
      <Card.Body>
        {formattedData.length === 0 ? (
          <div className="text-center p-4">
            <p className="text-muted">No hay datos disponibles para este período</p>
          </div>
        ) : (
          <ResponsiveContainer width="100%" height={300}>
            <ScatterChart
              margin={{ top: 5, right: 30, left: 20, bottom: 20 }}
            >
              <CartesianGrid strokeDasharray="3 3" />
              <XAxis 
                dataKey="fecha" 
                name="Fecha" 
                tick={{ fontSize: 12 }}
                angle={-20}
                textAnchor="end"
              />
              <YAxis 
                name="Caudal (m³/h)" 
                label={{ value: 'Caudal (m³/h)', angle: -90, position: 'insideLeft' }} 
                domain={['auto', 'auto']}
              />
              <Tooltip content={<CustomTooltip />} />
              <Legend />
              <Scatter 
                name="Caudal promedio diario" 
                data={formattedData} 
                fill="#8884d8"
                line={{ stroke: '#8884d8', strokeWidth: 2 }}
                lineType="joint"
                shape="circle"
                dataKey="caudal_promedio" 
              />
            </ScatterChart>
          </ResponsiveContainer>
        )}
      </Card.Body>
    </Card>
  );
};

export default WeeklyChart;